// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DevicesFranquias_ToggleWebsocketInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/devices_franquias/toggle_websocket
 *
 * Enables or disables WebSocket for a WhatsApp device via Evolution API.
 */
import { registerContract } from './validate'

export interface DevicesFranquias_ToggleWebsocketInput {
instance_name: string
enabled: boolean
}

registerContract('DevicesFranquias_ToggleWebsocketInput', {
  instance_name: { type: 'string',  required: true },
  enabled:       { type: 'boolean', required: true },
})
